/* eslint-disable no-empty-pattern */
import kitsu from '@plugins/kitsu';
import http from '@plugins/axios';
import { queryString } from '@utils/format';
let $ajax;

export const actions = {
  async fetch({ rootState }, payload) {
    const id = rootState.auth.instansi_id;

    let api = `peserta/${payload.type}`;
    if (payload.params && +payload.params.gelombang_profil >= 2) {
      api = 'dpp-pkp';
    }

    $ajax = kitsu({
      baseURL: process.env.VUE_APP_API_URL + `/psp/i/${id}/${api}`,
    });

    return await $ajax.get('/', { params: payload.params });
  },

  async getDetail({ rootState }, payload) {
    const id = rootState.auth.instansi_id;

    let api = `peserta/${payload.type}`;
    if (payload.api) {
      api = `dpp-pkp`;
    }

    $ajax = kitsu({
      baseURL: process.env.VUE_APP_API_URL + `/psp/i/${id}/${api}`,
    });

    return await $ajax.get(`/${payload.id}`);
  },

  async listPengawas({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    $ajax = kitsu({
      baseURL: process.env.VUE_APP_API_URL + `/psp/i/${id}/peserta/${payload.type}`,
    });
    return await $ajax.get(`/pengawas`, { params: payload.params });
  },

  async kandidat({ rootState }, payload) {
    const id = rootState.auth.instansi_id;

    let api = `peserta/${payload.type}`;
    if (payload.api) {
      api = 'dpp-pkp';
    }

    $ajax = kitsu({
      baseURL: process.env.VUE_APP_API_URL + `/psp/i/${id}/${api}`,
    });

    return await $ajax.get(`/${payload.id}/${payload.action || 'kandidat'}`, { params: payload.params });
  },

  async instansis({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    $ajax = kitsu({
      baseURL: process.env.VUE_APP_API_URL + `/psp/i/${id}/peserta/${payload.type}/dinas`,
    });
    return await $ajax.get('/');
  },

  async getDetailSekolah({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    $ajax = kitsu({
      baseURL: process.env.VUE_APP_API_URL + `/psp/i/${id}/peserta/${payload.type}/sekolah`,
    });
    return await $ajax.get(`/${payload.id}`);
  },

  gantiPeserta({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    const url = `psp/i/${id}/peserta/${payload.type}/sekolah/${payload.id}/ganti`;
    return http.post(url, payload.params).then(({ data }) => data);
  },

  create({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    const url = `psp/i/${id}/peserta/${payload.type}`;
    return http.post(url, payload.params).then(({ data }) => data);
  },

  update({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    const url = `psp/i/${id}/peserta/${payload.type}/${payload.id}/update`;
    return http.post(url, payload.params).then(({ data }) => data);
  },

  ajuan({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    const url = `psp/i/${id}/peserta/${payload.type}/ajuan-sekolah/${payload.id}`;
    return http.post(url, payload.params).then(({ data }) => data);
  },

  batalAjuan({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    const url = `psp/i/${id}/peserta/${payload.type}/batal-ajuan-sekolah/${payload.id}`;
    return http.post(url, payload.params).then(({ data }) => data);
  },

  action({ rootState }, payload) {
    const id = rootState.auth.instansi_id;

    let api = `peserta/${payload.type}`;
    if (payload.api) {
      api = 'dpp-pkp';
    }

    const url = `psp/i/${id}/${api}/${payload.id}/${payload.action}`;
    return http.post(url, payload.params).then(({ data }) => data);
  },

  downloadList({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    const url = `${process.env.VUE_APP_API_URL}/psp/i/${id}/peserta/${payload.type}/${payload.url}?${queryString(
      payload.params
    )}`;
    return Promise.resolve(url);
  },
};
